import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "sonner";
import {
  fetchStarFeedList,
  createStarFeed,
  updateStarFeed,
  deleteStarFeed,
  reorderStarFeed,
  StarFeedPayload,
  StarFeedOrderPayloadItem,
} from "src/services/star-feed.service";

interface FetchStarFeedListPayload {
  page: number;
  limit: number;
  search?: string;
}

interface UpdateStarFeedPayload {
  sfId: string;
  data: StarFeedPayload;
}

export const doFetchStarFeedList = createAsyncThunk(
  "starFeed/fetchStarFeedList",
  async (payload: FetchStarFeedListPayload) => {
    try {
      const response: any = await fetchStarFeedList({
        page: payload.page,
        limit: payload.limit,
        search: payload.search,
      });
      return response;
    } catch (error: any) {
      const errorMessage =
        error.response?.data?.message || "Failed to fetch star feed list";
      console.log(errorMessage);
      throw errorMessage;
    }
  },
);

export const doCreateStarFeed = createAsyncThunk(
  "starFeed/createStarFeed",
  async (payload: StarFeedPayload) => {
    try {
      const response: any = await createStarFeed(payload);
      toast.success(response.message || "Star feed created successfully");
      return response;
    } catch (error: any) {
      const errorMessage =
        error.response?.data?.message || "Failed to create star feed";
      toast.error(errorMessage);
      throw errorMessage;
    }
  },
);

export const doUpdateStarFeed = createAsyncThunk(
  "starFeed/updateStarFeed",
  async (payload: UpdateStarFeedPayload) => {
    try {
      const response: any = await updateStarFeed(payload.sfId, payload.data);
      toast.success(response.message || "Star feed updated successfully");
      return response;
    } catch (error: any) {
      const errorMessage =
        error.response?.data?.message || "Failed to update star feed";
      toast.error(errorMessage);
      throw errorMessage;
    }
  },
);

export const doDeleteStarFeed = createAsyncThunk(
  "starFeed/deleteStarFeed",
  async (sfId: string) => {
    try {
      const response: any = await deleteStarFeed(sfId);
      toast.success(response.message || "Star feed deleted successfully");
      return { sfId, ...response };
    } catch (error: any) {
      const errorMessage =
        error.response?.data?.message || "Failed to delete star feed";
      toast.error(errorMessage);
      throw errorMessage;
    }
  },
);

export const doReorderStarFeed = createAsyncThunk(
  "starFeed/reorderStarFeed",
  async (items: StarFeedOrderPayloadItem[]) => {
    try {
      const response: any = await reorderStarFeed(items);
      return { items, response };
    } catch (error: any) {
      const errorMessage =
        error.response?.data?.message || "Failed to update star feed order";
      toast.error(errorMessage);
      throw errorMessage;
    }
  },
);
